import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../services/api.js';

const initialState = {
  formData: {
    fullName: '',
    username: '',
    email: '',
    password: '',
    role: 'Collector',
  },
  error: '',
  success: '',
  mailStatus: { sending: false, message: '' },
};

export const sendWelcomeEmail = createAsyncThunk(
  'registerUserForm/sendWelcomeEmail',
  async ({ email, username, password, fullName }, { rejectWithValue }) => {
    try {
      await api.post('/emails/welcome', {
        to: email,
        username,
        password,
        fullName,
      });
      return { message: 'Welcome email sent.' };
    } catch (error) {
      const message =
        error?.response?.data?.message || 'Welcome email failed to send.';
      return rejectWithValue({ message });
    }
  }
);

const registerUserFormSlice = createSlice({
  name: 'registerUserForm',
  initialState,
  reducers: {
    setFormData(state, action) {
      state.formData = action.payload;
    },
    updateFormField(state, action) {
      const { field, value } = action.payload;
      state.formData = { ...state.formData, [field]: value };
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setSuccess(state, action) {
      state.success = action.payload;
    },
    resetMessages(state) {
      state.error = '';
      state.success = '';
      state.mailStatus = { sending: false, message: '' };
    },
    resetForm(state) {
      state.formData = initialState.formData;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendWelcomeEmail.pending, (state) => {
        state.mailStatus = { sending: true, message: '' };
      })
      .addCase(sendWelcomeEmail.fulfilled, (state, action) => {
        state.mailStatus = { sending: false, message: action.payload.message };
      })
      .addCase(sendWelcomeEmail.rejected, (state, action) => {
        state.mailStatus = {
          sending: false,
          message: action.payload?.message || 'Welcome email failed to send.',
        };
      });
  },
});

export const {
  setFormData,
  updateFormField,
  setError,
  setSuccess,
  resetMessages,
  resetForm,
} = registerUserFormSlice.actions;

export const selectRegisterUserForm = (state) => state.registerUserForm;

export default registerUserFormSlice.reducer;
